var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.to
      ? _c(
          "a",
          {
            staticClass: "ivu-cell-link",
            attrs: { href: _vm.linkUrl, target: _vm.target },
            on: {
              click: [
                function($event) {
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  ) {
                    return null
                  }
                  return _vm.handleClickItem($event, false)
                },
                function($event) {
                  if (!$event.ctrlKey) {
                    return null
                  }
                  return _vm.handleClickItem($event, true)
                },
                function($event) {
                  if (!$event.metaKey) {
                    return null
                  }
                  return _vm.handleClickItem($event, true)
                }
              ]
            }
          },
          [
            _c(
              "CellItem",
              {
                attrs: { title: _vm.title, label: _vm.label, extra: _vm.extra }
              },
              [
                _vm._t("icon", null, { slot: "icon" }),
                _vm._v(" "),
                _vm._t("default", null, { slot: "default" }),
                _vm._v(" "),
                _vm._t("extra", null, { slot: "extra" }),
                _vm._v(" "),
                _vm._t("label", null, { slot: "label" })
              ],
              2
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "ivu-cell-link", on: { click: _vm.handleClickItem } },
          [
            _c(
              "CellItem",
              {
                attrs: { title: _vm.title, label: _vm.label, extra: _vm.extra }
              },
              [
                _vm._t("icon", null, { slot: "icon" }),
                _vm._v(" "),
                _vm._t("default", null, { slot: "default" }),
                _vm._v(" "),
                _vm._t("extra", null, { slot: "extra" }),
                _vm._v(" "),
                _vm._t("label", null, { slot: "label" })
              ],
              2
            )
          ],
          1
        ),
    _vm._v(" "),
    _vm.to
      ? _c(
          "div",
          { staticClass: "ivu-cell-arrow" },
          [
            _vm._t("arrow", function() {
              return [
                _c("Icon", {
                  attrs: {
                    type: _vm.arrowType,
                    custom: _vm.customArrowType,
                    size: _vm.arrowSize
                  }
                })
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69925e45", { render: render, staticRenderFns: staticRenderFns })
  }
}